import type { RefObject } from 'react';
import { createContext } from 'react';

type ChartRefContext = HTMLDivElement;

export const ChartRefContext = createContext<ChartRefContext>(null);